
import React from "react";
import { checkSession, getBrand, setFavicon } from "../lib/functions";
import Header from "./Header.js";
import Login from "./Login.js";
import FadeIn from "./Fadein.js";
import Main from "./Main.js";
import { Fragment } from "react";

export default class Application extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loggedIn: false,
      brand: {},
      sessionChecked: false,
      student: ""
    };
  }


  /**
 * React lifecycle method. - OUTDATED WE NEED TO USE USEEFFECT INSTEAD
 * On mount, retrieves brand information, sets it in state, checks for an existing user session,
 * updates authentication state, and sets the favicon.
 */


  componentDidMount = () => {

    // this is the assignmentkey. If this is sent with the URL, 
    // we will redirect to the assignment after login.
    const params = new URLSearchParams(window.location.search);
    this.setState({ launchme: params.get('a')});

    const brand = getBrand();
    this.setState({ brand: brand });
    checkSession((data) => {

      let valid = data.valid;

      this.setState({ loggedIn: valid, sessionChecked: true });
      if (valid) this.setState({ student: data });

    });
    setFavicon(brand.favicon);
  };

  /**
 * Callback to update state when a user successfully logs in.
 * @param {Object} student - The student/user data returned after login.
 */
  loggedIn = (student) => {
    this.setState({ loggedIn: true, student: student });
  };

  /**
 * Opens a help URL in a new browser tab if the triggering element has a 'data-url' attribute.
 * @param {Event} e - The event object from the click handler.
 */
  gethelp = (e) => {
    let url = e.currentTarget.getAttribute('data-url');
    if (url) window.open(url);

  };

/**
 * If all 3 things are true, logged in, session is checked and launchme is set, then redirect to assignment. 
 * @param {*} prevProps 
 * @param {*} prevState 
 */
  componentDidUpdate(prevProps, prevState) {
 
  if (
    this.state.loggedIn && 
    this.state.sessionChecked && 
    this.state.launchme
  ) {
    window.location.href = `/osa/?a=${this.state.launchme}`;
  }
}

  /**
 * Renders the application UI.
 * Shows the login screen if not authenticated, otherwise shows the main content.
 * @returns {JSX.Element}
 */
  render() {
    return (
      <Fragment>

        {!this.state.loggedIn && this.state.sessionChecked ?
          <>
            <Header student={this.state.student} gethelp={this.gethelp} />
            <FadeIn>
              <Login loggedIn={this.loggedIn} gethelp={this.gethelp} launchme={this.state.launchme} />
            </FadeIn>
          </>
          : null
        }

        {this.state.loggedIn && this.state.sessionChecked && !this.state.launchme ?
          <Main student={this.state.student} gethelp={this.gethelp} />
          : null}
      </Fragment>
    );
  }
}
